import { render, staticRenderFns } from "./PriceAndProductInformation.vue?vue&type=template&id=149f4a86"
import script from "./PriceAndProductInformation.vue?vue&type=script&lang=js"
export * from "./PriceAndProductInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports